var render, staticRenderFns
import script from "./CardItem.vue?vue&type=script&lang=js&"
export * from "./CardItem.vue?vue&type=script&lang=js&"
import style0 from "./CardItem.vue?vue&type=style&index=0&lang=css&"
import style1 from "./CardItem.vue?vue&type=style&index=1&id=3a4ae3e3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a4ae3e3",
  null
  
)

component.options.__file = "CardItem.vue"
export default component.exports